import { AwsConfig as AwsConstants } from '../Constants';
import { Dashboard } from '@interfaces/ehss/Dashboard';
import BaseService, { RequestInterface } from '../Base';
import DashboardQuery from '@interfaces/ehss/dashboard-query';

export default class DashboardService extends BaseService {
    constructor() {
        super(AwsConstants.API_EHSS, 'dashboard');
    }

    async getAuditsDone(unitId: string, fields?: string[]): Promise<Dashboard> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        params.queryStringParameters['unit'] = unitId;

        const res = await super.get<Dashboard>('audition', params);
        return res;
    }
    async getData(link: string, query: DashboardQuery, fields?: string[]): Promise<Dashboard> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };

        if (query.unit) {
            params.queryStringParameters['unit'] = query.unit;
        }
        if (query.year) {
            params.queryStringParameters['year'] = query.year;
        }
        if (query.field) {
            params.queryStringParameters['field'] = query.field;
        }
        if (query.value) {
            params.queryStringParameters['value'] = query.value;
        }

        if (query.type) {
            params.queryStringParameters['type'] = query.type;
        }

        const res = await super.get<Dashboard>(`${link}`, params);
        return res;
    }

    async getDashboard( query: DashboardQuery): Promise<Dashboard> {
        const params: RequestInterface = {
            queryStringParameters: {}
        };

        if (query.unit) {
            params.queryStringParameters['unit'] = query.unit;
        }
        if (query.from) {
            params.queryStringParameters['from'] = query.from;
        }
        if (query.to) {
            params.queryStringParameters['to'] = query.to;
        }
        if (query.field) {
            params.queryStringParameters['field'] = query.field;
        }
        if (query.value) {
            params.queryStringParameters['value'] = query.value;
        }
        if (query.process) {
            params.queryStringParameters['process'] = query.process;
        }
        if (query.auditor) {
            params.queryStringParameters['auditor'] = query.auditor;
        }
        if (query.audited) {
            params.queryStringParameters['audited'] = query.audited;
        }
        if (query.auditedOut) {
            params.queryStringParameters['auditedOut'] = query.auditedOut;
        }
        if (query.auditorGuest) {
            params.queryStringParameters['auditorGuest'] = query.auditorGuest;
        }
        if (query.status) {
            params.queryStringParameters['status'] = query.status;
        }

        const res = await super.get<Dashboard>('ticket/dashboard', params);
        return res;
    }

    async addWidget (id: string, unit: string,  widget: any){
        const params: RequestInterface = {
            body: widget,
            queryStringParameters: { unit: unit }
        };
        const res = await super.patch<any>(`${id}/widget`, params);
        return res;
    }

    async editWidget(id: string, widgetID: any, widgetBody: any, unit: any){
        const params: RequestInterface = {
            body: widgetBody,
            queryStringParameters: { unit: unit }
        }   
        const res = await super.patch<any>(`${id}/widget/${widgetID}`, params);
        return res;
    }

    async deleteWidget (unitId: string, id: string, widgetID: any): Promise<void> {
        const params: RequestInterface = {
            queryStringParameters: { unit: unitId }
        };
        await super.delete<void>(`${id}/widget/${widgetID}`, params);
    }

    async editWidgetPosition(id: string, unit:any, widgetID: any, index: any) {
        const params: RequestInterface = {
          queryStringParameters: { unit: unit }
      }  
        const res = await super.patch<any>(`${id}/widget/${widgetID}/index/${index}`, params);
        return res;
      }

    async paging(query: BasePaginationQuery, fields?: string[]): Promise<IPagination<IProcess>> {
        const params: RequestInterface = {
          queryStringParameters: super.setFields(fields)
        };
        if (query.unit) {
          params.queryStringParameters['unit'] = query.unit;
        }
        if (query.limit) {
          params.queryStringParameters['limit'] = query.limit;
        }
        if (query.offset) {
          params.queryStringParameters['offset'] = query.offset;
        }
        if (query.from) {
          params.queryStringParameters['from'] = query.offset;
        }
        if (query.to) {
          params.queryStringParameters['to'] = query.offset;
        }
        if (query.search) {
          params.queryStringParameters['search'] = query.search; // by name
        }
    
        const res = await super.get<IPagination<IProcess>>('', params);
        return res;
    }

    async create(data: any, unit: string): Promise<any> {
    const params: RequestInterface = {
        body: data,
        queryStringParameters: { unit: unit }
    };
    const res = await super.post<any>('', params);
    return res;
    }

}
